import { memo, useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";

const Portal = ({ id, children, styles, portalClass }) => {
  const el = useRef(document.getElementById(id) || document.createElement("div"));
  const [dynamic] = useState(!el.current.parentElement);

  useEffect(() => {
    const element = el.current;
    if (!element) return;

    element.classList.add("portal");
    if (portalClass) {
      for (const clazz of portalClass.split(" ")) {
        element.classList.add(clazz);
      }
    }
    if (styles) {
      for (const [property, value] of Object.entries(styles)) {
        element.style[property] = value;
      }
    }

    if (dynamic) {
      if (id) {
        element.id = id;
      }
      document.body.appendChild(element);
    }
    return () => {
      if (dynamic && element.parentElement) {
        element.parentElement.removeChild(element);
      }
    };
  }, [id, dynamic, portalClass, styles]);

  return createPortal(children, el.current);
};
export default memo(Portal);
